module.exports = __webpack_public_path__ + "img/p3.fdd4443a.png";